var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "row" },
      [
        _vm._l(_vm.requestData.data, function (post) {
          return _c("div", { key: post.id, staticClass: "col-3 mb-3" }, [
            _c("div", { staticClass: "ratio ratio-1x1" }, [
              _c("div", { staticClass: "overflow-hidden rounded" }, [
                _c("a", { attrs: { href: _vm.postLink(post) } }, [
                  _c("img", {
                    staticStyle: {
                      width: "100%",
                      height: "100%",
                      "object-fit": "cover",
                    },
                    attrs: {
                      src: `https://djceg34j53tq.cloudfront.net/${post.image}`,
                    },
                  }),
                ]),
              ]),
            ]),
          ])
        }),
        _vm._v(" "),
        _vm.requestData.next_page_url
          ? _c("div", { staticClass: "col-12 text-center" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-link",
                  on: { click: _vm.loadMoreData },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm._f("translate")("More")) +
                      "\n      "
                  ),
                ]
              ),
            ])
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }